<template>
    <div class="MessageContent UploadingBox">
        <v-spacer v-if="!isUser"></v-spacer>
        <div class="__container">
             <div class="box-uploading-failed" v-if="display_error">
                <v-icon>mdi-alert</v-icon> <span>Can't upload file</span>
            </div>
            <div class="__loading" v-else>
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
            <div class="file-name" :title="fileName">{{ fileName }}</div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentUploading",
    extends: MessageContent,
    data () {
        return {
            fileName: this.content.file_name
        }
    },
    computed: {
        display_error () {
            return this.content.status && this.content.status === 'failed'
        }
    }
}
</script>
<style lang="scss" scoped src="../../style/message-box.scss"></style>
<style scoped>
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }

    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }

    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }

    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .UploadingBox {
        width: 100%;
        position: relative;
        opacity: 0.7;
    }

    .UploadingBox .__container {
        width: 250px;
        height: 150px;
        background-color: #2A4E69;
        border-radius: 5px;
        text-align: center;
        position: relative;

    }

    .UploadingBox .__container .__loading {
        position: relative;
        top: calc(50% - 40px);
    }

    .UploadingBox .file-name {
        width: 100%;
        position: absolute;
        bottom: 10px;
        color: #fff;
        padding: 0 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .UploadingBox .box-uploading-failed {
        margin-top: 20px;
    }

    .UploadingBox .box-uploading-failed i {
        font-size: 50px !important;
        color: #ff8c00;
    }

    .UploadingBox .box-uploading-failed span {
        display: block;
        margin: 5px 0;
        color: #ff8c00;
    }
</style>
